import { render } from "./listitems.component.vue?vue&type=template&id=16951588"
import script from "./listitems.component.vue?vue&type=script&lang=js"
export * from "./listitems.component.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__